import React, { useState, useEffect } from 'react';
import { Card, CardMedia, useTheme } from '@mui/material';
import { obtenerImagenCabezal } from '../../services/motorService';
import Cookies from 'js-cookie';
import cabezalEnBlanco from './cabezalEnBlanco.jpg';
function Banner() {
  const [bannerUrl, setBannerUrl] = useState(null);
  const theme = useTheme();
  const hotCod = Cookies.get('hotCod');

  useEffect(() => {

    const fetchBannerImage = async () => {
      try {
        const imagenBase64 = await obtenerImagenCabezal(hotCod);
        if(imagenBase64.startsWith('Imagen del Cabezal Sin Datos para el hotel')){
          setBannerUrl(cabezalEnBlanco);
        }else{
          setBannerUrl(`data:image/png;base64,${imagenBase64}`);
        }
        
      } catch (error) {
        console.error('Error fetching header image:', error);
      }
    };

    fetchBannerImage();
  }, []);

  return (
    <Card sx={{ maxWidth: '100%', height: 'auto', position: 'relative', margin: '0 auto' }}>
      <CardMedia
        component="img"
        src={bannerUrl}
        alt="cabezal"
        height="140" // Altura de la imagen
        sx={{
          [theme.breakpoints.up('sm')]: {
            height: 200, // Ajuste para pantallas más grandes (sm y superiores)
          },
        }}
      />
    </Card>
  );

}

export default Banner;